import React from "react";
import { ErrorIcon } from "../../assets/icon";

import s from "./FormInput.module.scss";

function FormInput({ ...props }) {
  const { errors, register, name, label, subLabelButton, required, placeholder } = props;

  return (
    <div className={s.form_group}>
      {label && (
        <label className={s.label} htmlFor={name}>
          {label} {required && <span style={{color: '#2079CB'}}>*</span>}
        </label>
      )}
      <div className={s.input_box}>
        <input
          className={!!errors && errors[name] ? `${s.is_invalid}` : ``}
          name={name}
          ref={!!register ? register : null}
          type={name}
          id={name}
          placeholder={placeholder}
          maxLength={name === "zip" && 3}
        />
        <div className={s.error_icon}>
          {!!errors && errors[name]?.message && <ErrorIcon />}
        </div>
      </div>
      {subLabelButton && (
        <label className={s.subLabelButton} htmlFor={name}>
          {subLabelButton}
        </label>
      )}

      <div className={s.error}>{!!errors && errors[name]?.message}</div>
    </div>
  );
}

export default FormInput;
